export const esLang = {
  languageKey: 'es',
  translates: {
    // log_in: 'Iniciar sesión',
    // logging_in: 'Iniciando sesión...',
    // log_out: 'Cerrar sesión',
    // logout: 'Cerrar sesión',
    // search: 'Buscar',
    // generate_password: 'Generar contraseña',

    // // language selector:
    // english: 'Inglés',
    // spanish: 'Español',
    // portuguese: 'Portugués',

    // // TRANSLATES RELATED DIRECTLY WITH URL PATH, DON'T TOUCH THEM.
    // dashboard: 'Panel de control',
    // profile: 'Perfil',
    // my_profile: 'Mi perfil',
    // detail: 'Detalle',
    // edit: 'Editar',
    // 'billing-info': 'Datos de facturación',
    // 'requester-companies': 'Prescriptores',
    // 'supplier-companies': 'Sociedades de tasación',
    // list: 'Listado',
    // entities: 'Entidades',
    // // END - TRANSLATES RELATED DIRECTLY WITH URL PATH, DON'T TOUCH THEM.

    // // ERRORS
    // required: 'Este campo es obligatorio',
    // not_valid_email: 'Email no válido',
    // minlength: 'Longitud mínima {{value}}',
    // // END - ERRORS

    // MENU_dashboard: 'Panel de control',
    // MENU_ORDERS_requests: 'Solicitudes',
    // MENU_ORDERS_list: 'Listado',
    // MENU_ASSETS_assets: 'Activos',
    // MENU_ASSETS_add: 'Añadir',
    // MENU_ASSETS_list: 'Listado',
    // MENU_ASSESSMENTS: 'Valoraciones',
    // MENU_ASSESSMENTS_add: 'Añadir Valoración',
    // MENU_ASSESSMENTS_massive_load: 'Carga masiva',
    // MENU_ASSESSMENTS_portfolios: 'Carteras',
    // MENU_ASSESSMENTS_orders: 'Encargos',
    // MENU_ASSESSMENTS_orders_all: 'Todas',
    // MENU_ASSESSMENTS_orders_pendingToAssignManager: 'Pendientes de Asignar Responsable',
    // MENU_ASSESSMENTS_orders_toAssign: 'Pendientes de Asignar Técnico',
    // MENU_ASSESSMENTS_orders_pendingToSchedule: 'Pendientes de Agendar',
    // MENU_ASSESSMENTS_orders_scheduledByTec: 'Agendadas por Técnico',
    // MENU_ASSESSMENTS_orders_inProcess: 'In process',
    // MENU_ASSESSMENTS_orders_deliveredByAppraiser: 'Delivered by technician',
    // MENU_ASSESSMENTS_orders_validationProcess: 'Validation in Progress',
    // MENU_ASSESSMENTS_orders_validated: 'Validated',
    // MENU_ASSESSMENTS_orders_deliveredToClient: 'Delivered to Client',
    // MENU_ASSESSMENTS_orders_alive: 'Appraisals Actives',
    // MENU_ASSESSMENTS_orders_cancelled: 'Cancelled',
    // MENU_ASSESSMENTS_incidents: 'Incidents',
    // MENU_ASSESSMENTS_claims: 'Claims',
    // MENU_QUALITYCONTROL: 'Quality control',
    // MENU_QUALITYCONTROL_createOrder: 'Create order',
    // MENU_QUALITYCONTROL_orders: 'Encargos',
    // MENU_QUALITYCONTROL_orders_all: 'Todas',
    // MENU_QUALITYCONTROL_orders_pendingToAssignProcessManager: 'Pending to Assign Process Manager',
    // MENU_QUALITYCONTROL_orders_pendingToAssignTechnicalManager: 'Pending to Assign Technical Manager',
    // MENU_QUALITYCONTROL_orders_pending2AssignTechnical: 'Pending to Assign Technical',
    // MENU_QUALITYCONTROL_orders_pendingToStartValidation: 'Pending to start Validation',
    // MENU_QUALITYCONTROL_orders_validating: 'Validation in progress',
    // MENU_QUALITYCONTROL_orders_validationFinished: 'Validation finished',
    // MENU_QUALITYCONTROL_orders_deliveredToClient: 'Delivered to Client',
    // MENU_QUALITYCONTROL_orders_alive: 'Appraisals Actives',
    // MENU_QUALITYCONTROL_orders_cancelled: 'Cancelled',
    // MENU_CLAIMS: 'Claims',
    // MENU_ENTITIES: 'Entidades',
    // MENU_ENTITIES_prescribers: 'Prescriptores',
    // MENU_ENTITIES_customers: 'Clientes',
    // MENU_ENTITIES_appraisal_companies: 'Sociedades de tasación',
    // MENU_ENTITIES_users: 'Usuarios',
    // MENU_CLIENTS: 'Clients',
    // MENU_USERS: 'Usuarios',
    // MENU_USERS_professionals: 'Profesionales',
    // MENU_USERS_processManagers: 'Usuarios Gestores de Procesos',
    // MENU_USERS_processManagers_list: 'Listado',
    // MENU_USERS_processManagers_statistics: 'Statistics',
    // MENU_USERS_techManagers: 'Usuario Gestores de Técnicos',
    // MENU_USERS_techManagers_list: 'Listado',
    // MENU_FINANCIAL: 'Financial',
    // MENU_FINANCIAL_paymentSummary: 'Payment Summary',
    // MENU_FINANCIAL_paymentSummary_allInvoices: 'Todas las facturas',
    // MENU_FINANCIAL_paymentSummary_pendingToSendToInvoicer: 'Pending confirmation request',
    // MENU_FINANCIAL_paymentSummary_sendToRevisionToInvoicer: 'Confirmation sent',
    // MENU_FINANCIAL_paymentSummary_confirmedByInvoicer: 'Confirmed',
    // MENU_FINANCIAL_paymentSummary_rejectedByInvoicer: 'Rejected',

    // MY_PROFILE_MODAL_my_profile: 'Mi perfil',
    // MY_PROFILE_MODAL_save: 'Guardar',
    // MY_PROFILE_MODAL_confirm: 'Confirmar',
    // MY_PROFILE_MODAL_confirming: 'Confirmando',
    // MY_PROFILE_MODAL_cancel: 'Cancelar',
    // MY_PROFILE_MODAL_cancelling: 'Cancelando',

    // Code: 'Código',
    // code: 'Código',
    // PrescriptorType: 'Tipo de prescriptor',
    // Name: 'Nombre',
    // name: 'Nombre',
    // add_prescriber: 'Añadir prescriptor',
    // prescribers: 'Prescriptores',
    // appraisals: 'Tasaciones',
    // users: 'Usuarios',
    // IsActive: 'Usuario activo',
    // FirstName: 'Nombre',
    // LastName: 'Apellidos',
    // Requester: 'Prescriptor',
    // Email: 'Email',
    // email: 'Email',
    // deliverables: 'Entregables',
    // billing_info: 'Datos de Facturación',
    // typology: 'Tipología',
    // cif_nif: 'CIF/NIF',
    // cif: 'CIF',
    // nif: 'NIF',
    // phone: 'Teléfono',
    // description: 'Descripción',
    // observations: 'Observaciones',
    // IrpfPercentage: 'Porcentaje de Retención de IRPF (%)',
    // irpfPercentage: 'Porcentaje de Retención de IRPF (%)',
    // BillingTaxType: 'Tipo de impuesto',
    // billingTaxType: 'Tipo de impuesto',
    // tax: 'Impuesto',
    // bank_account_number_for_payment: 'Numero de Cuenta Bancaria para el pago',

    // name_or_business_name: 'Nombre o razón social',
    // withholding: 'Retención de %IRPF',
    // tax_type: 'Tipo de impuesto',

    // restart: 'Reiniciar',
    // filter: 'Filtrar',
    // cancel: 'Cancelar',
    // save: 'Guardar',
    // saving: 'Guardando...',
    // close: 'Cerrar',
    // confirm: 'Confirmar',

    // RecordId: 'Nº expediente',
    // GestasaId: 'Nº Gestasa',
    // ExternalRecordId: 'Nº de referencia externa',
    // Address: 'Dirección',
    // address: 'Dirección',
    // Locality: 'Localidad',
    // locality: 'Localidad',
    // Province: 'Provincia',
    // province: 'Provincia',
    // AddedDateTime: 'Fecha de creación',
    // CurrentWorkflowStep: 'Estado',
    // ProcessManagerUser: 'Gestor de procesos',
    // TechnicalManagerUser: 'Gestor de técnicos',
    // Customer: 'Cliente',
    // customers: 'Clientes',

    // postalCode: 'Código Postal',
    // gate: 'Puerta',
    // floor: 'Planta',
    // stairs: 'Escalera',
    // entrance: 'Portal',
    // number: 'Número',
    // streetName: 'Nombre vía',
    // streetType: 'Tipo de vía',
    // roadType: 'Tipo de vía',
    // change_picture: 'Cambiar imagen',

    // AppraisalStatus_1: '1 - ALTA',
    // AppraisalStatus_2: '2 - RESPONSABLE ASIGNADO',
    // AppraisalStatus_3: '3 - TÉCNICO ASIGNADO',
    // AppraisalStatus_4: '4 - VISITA AGENDADA',
    // AppraisalStatus_5: '5 - VISITA EMPEZADA',
    // AppraisalStatus_6: '6 - VISITA FINALIZADA',
    // AppraisalStatus_7: '7 - INFORME ENTREGADO',
    // AppraisalStatus_8: '8 - VALIDADOR ASIGNADO',
    // AppraisalStatus_9: '9 - VALIDACIÓN EMPEZADA',
    // AppraisalStatus_10: '10 - VALIDACIÓN CORRECTA',
    // AppraisalStatus_11: '11 - ENTREGADA A CLIENTE ',

    // DELIVERABLE_REPOSITORY_addRow: '+ Añadir nuevo entregable',
    // DELIVERABLE_REPOSITORY_deliverable: 'Entregable',
    // DELIVERABLE_REPOSITORY_orderType: 'Tipo de encargo',
    // DELIVERABLE_REPOSITORY_prupose: 'Finalidad',
    // DELIVERABLE_REPOSITORY_source: 'Origen',

    // DELIVERABLE_MODAL_deliverable: 'Entregable',
    // DELIVERABLE_MODAL_documentName: 'Nombre de documento',
    // DELIVERABLE_MODAL_generationDate: 'Fecha de generación',
    // DELIVERABLE_MODAL_emissionDate: 'Fecha de emisión',
    // DELIVERABLE_MODAL_expirationDate: 'Fecha de caducidad',
    // DELIVERABLE_MODAL_documentVersion: 'Version documento',
    // DELIVERABLE_MODAL_downloadAll: 'Descargar todos',
    // DELIVERABLE_MODAL_downloading: 'Descargando',
    // DELIVERABLE_MODAL_internal: 'Interno',
    // DELIVERABLE_MODAL_external: 'Externo',

    // add_new_prescriptor: '+ Añadir nuevo prescriptor',

    // an_error_has_ocurred: 'Ha ocurrido un error',
    // the_action_was_successful: 'La acción se ha realizado correctamente',
    // successfully_completed: 'Realizado con éxito',
    // account_number_for_payments: 'Número de cuenta bancaria para el pago',

    // // New Added for professionals module
    // BooleanQuestionValues_true: 'Sí',
    // BooleanQuestionValues_false: 'No',
    // add_new_professional: '+ Añadir nuevo profesional',
    // city: 'Ciudad',
    // professionals: 'Profesionales',
    // PROFESSIONALS_NEW_add_professional: 'Añadir tasador',
    // degree: 'Titulación',
    // externalCode: 'Código Externo',
    // latitude: 'Latitud',
    // longitude: 'Longitud',
    // password: 'Contraseña',
    // confirmPassword: 'Repite la contraseña',
    // collaborator: 'Colaborador',
    // collaboratorCheckbox: '¿Colaborador?',
    // signature: 'Firma',
    // participants: 'Participantes',
    // orders: 'Encargos',
    // actives: 'Activos',
    // add: 'Añadir',
    // claims: 'Reclamaciones',
    // incidents: 'Incidencias',
    // requests: 'Solicitudes',
    // 'quality-control': 'Control de calidad',
    // 'simple-notes': 'Notas simples',

    // PROPERTY_DATA_TABLE_CadastralReference: 'Referencia catastral',
    // PROPERTY_DATA_TABLE_RegistryInfoRegister: 'Registro de la propiedad',
    // PROPERTY_DATA_TABLE_RegistryInfoRegisterNumber: 'Número de finca registral',
    // PROPERTY_DATA_TABLE_RegistryInfoIdufir: 'C.R.U. (IDUFIR)',
    // PROPERTY_DATA_TABLE_RegistryInfoVolume: 'Tomo',
    // PROPERTY_DATA_TABLE_RegistryInfoBook: 'Libro',
    // PROPERTY_DATA_TABLE_RegistryInfoSection: 'Folio',
    // PROPERTY_DATA_TABLE_RegistryInfoInscription: 'Inscripción',
    // PROPERTY_DATA_TABLE_RegistryInfoRealEstateNumber: 'Finca',
    // PROPERTY_DATA_TABLE_adress: 'Dirección',
    // PROPERTY_DATA_TABLE_refCatastral: 'Ref. catastral',
    // PROPERTY_DATA_TABLE_tipologyAndUse: 'Uso y tipología',
    // PROPERTY_DATA_TABLE_surface: 'Superficie',
    // PROPERTY_DATA_TABLE_antiquity: 'Antigüedad',
    // PROPERTY_DATA_TABLE_estimatedValueBand: 'Franja de valor estimado',
    // PROPERTY_DATA_TABLE_total: 'Total:',
    // PROPERTY_DATA_TABLE_pruposedProperty: 'Tarifa propuesta',
    // ORDER_REQUEST_DETAIL_registerData: 'Datos registrales',
    // ORDER_REQUEST_DETAIL_euro: 'EUROS(sin tasas).',

    // ADD_NEW_ASSET_FORM_location: 'Localización',
    // ADD_NEW_ASSET_FORM_addManualy: 'Añadir manualmente',
    // ADD_NEW_ASSET_FORM_province: 'Provincia',
    // ADD_NEW_ASSET_FORM_municipality: 'Municipio',
    // ADD_NEW_ASSET_FORM_streetName: 'Nombre vía',
    // ADD_NEW_ASSET_FORM_number: 'Número',
    // ADD_NEW_ASSET_FORM_Block: 'Bloque',
    // ADD_NEW_ASSET_FORM_Stairs: 'Escalera',
    // ADD_NEW_ASSET_FORM_Floor: 'Piso',
    // ADD_NEW_ASSET_FORM_Gate: 'Puerta',
    // ADD_NEW_ASSET_FORM_Use: 'Uso',
    // ADD_NEW_ASSET_FORM_Typologies: 'Tipología',
    // ADD_NEW_ASSET_FORM_Surface: 'Superficie',
    // ADD_NEW_ASSET_FORM_ConstructionYear: 'Antigüedad',
    // ADD_NEW_ASSET_FORM_cadastralReference: 'Referencia catastral',
    // ADD_NEW_ASSET_FORM_propertyRegister: 'Registro propiedad',
    // ADD_NEW_ASSET_FORM_propertyRegisterNumber: 'Numero de finca registral',
    // ADD_NEW_ASSET_FORM_idufir: 'C.R.U (IDUFIR)',
    // ADD_NEW_ASSET_FORM_volume: 'Tomo',
    // ADD_NEW_ASSET_FORM_book: 'Libro',
    // ADD_NEW_ASSET_FORM_paper: 'Folio',
    // ADD_NEW_ASSET_FORM_inscription: 'Inscripción',
    // ADD_NEW_ASSET_FORM_realState: 'Finca',
    // ADD_NEW_ASSET_FORM_add: 'Añadir',
    // ORDER_REQUEST_DETAIL_addNewAsset: '+ Añadir nuevo activo',
    // ORDER_REQUEST_DETAIL_cancel: '- Cancelar',
    // ORDER_REQUEST_DETAIL_showDetail: 'Ver detalle',

    // InvoiceStatus_0: 'Pendiente de solicitar confirmación',
    // InvoiceStatus_1: 'Confirmación enviada',
    // InvoiceStatus_2: 'Confirmada',
    // InvoiceStatus_3: 'Rechazada',

    // MonthsEnum_1: 'Enero',
    // MonthsEnum_2: 'Febrero',
    // MonthsEnum_3: 'Marzo',
    // MonthsEnum_4: 'Abril',
    // MonthsEnum_5: 'Mayo',
    // MonthsEnum_6: 'Junio',
    // MonthsEnum_7: 'Julio',
    // MonthsEnum_8: 'Agosto',
    // MonthsEnum_9: 'Septiembre',
    // MonthsEnum_10: 'Octubre',
    // MonthsEnum_11: 'Noviembre',
    // MonthsEnum_12: 'Diciembre',

    // financial: 'Financiera',
    // 'code-management': 'Gestión de códigos',
    // 'payment-summary': 'Resumen de pagos',
    // 'users-credentials': 'Usuarios con credenciales',
    // 'process-manager-user': 'Usuario gestor de procesos',
    // 'technical-manager-user': 'Usuario gestor de técnicos',
    // 'commercial-manager-user': 'Usuario gestor comercial',

    // process_managers: 'Gestores de Procesos',
    // technical_managers: 'Gestores de Técnicos',
    // commercial_managers: 'Gestores Comerciales',
    // // Añadidos
    // isUserActive: 'Usuario activo',
    // valuations: 'Valoraciones',
    // deliverablesConfiguration: 'Configuración de entregables',
    // incompatibilities: 'Incompatibilidades',
    // position: 'Cargo',
    // extract: 'Extracto',
    // familiarRelationShip: 'Parentesco',
    // assignRoles: 'Asignar roles',
    // root: 'Root',
    // admin: 'Administrador',
    // manager: 'Responsable',
    // yesWithoutSaving: 'Sí, sin guardar',
    // yesSaving: 'Sí, guardando',
    // existFormChanges: 'Hay cambios en el formulario',
    // sureWantToExit: '¿Esta seguro de que quiere salir? Tiene cambios pendientes por guardar.',
    // change_password: 'Cambiar contraseña',
    // addIncompatibilities: 'Añadir incompatibilidades',
    // processDept: 'Departamento de Procesos',
    // externalTech: 'Técnico externo',
    // technicalDept: 'Departamento Técnico',
    // document: 'Documento',

    // ADD_NEW_ASSET_FORM_postalCode: 'Código postal',
    // ADD_NEW_ASSET_FORM_streeDoseNotExist: 'No está en el callejero',

    // assessments: 'Valoraciones',
    // nationalIdentityDocument: 'Documento nacional de identidad',
    // tab_information_updated_please_reload_tab: 'La información ha sido actualizada. Recargue la pestaña.',
    // TECHNICAL_MANAGER_USERS_add_technical_manager_user: 'Añadir gestor de técnicos',
    // no_documents: 'No hay documentos',
    // from: 'Desde',
    // toDate: 'Hasta',
    // cancelledDate: 'Fecha de anulación',
    // finishedDate: 'Finished de finalizacion',

    // REQUESTS_billing: 'Facturación',
    // REQUESTS_createNewInvoice: 'Crear nueva factura',
    // incomeOrExpensesProvision: 'Provisión Ingresos/Gastos',
    // incomeOrExpensesInvoiced: 'Facturación Ingresos/Gastos',
    // billingType: 'Tipo de facturación',
    // billingStatus: 'Estado facturación',
    // relatedAppraisals: 'Valoraciones relacionadas',
    // finishedAppraisals: 'Valoraciones finalizadas',
    // appraisalsWithInvoice: 'Valoraciones con factura',
    // amountsSummary: 'Resumen de importes',
    // invoices: 'Facturas',
    // generalData: 'Datos generales',
    // addValorationToRequestInvoice: 'Añadir valoración a factura',
    // selectAmountToIncludeInInvoice: 'Seleccione el importe a incluir en la factura',
    // confirmInvoice: 'Confirmar factura',
    // requestCreateInvoiceModalMsg1: 'La provision de importe incluido en la solicitud es',
    // requestCreateInvoiceModalMsg2: 'Indique el importe a facturar',
    // requestCreateInvoiceModalMsg3:
    //   'Se va a generar la factura para las valoraciones seleccionadas y por el importe indicado. Esta factura no se podrá modificar. ¿Está seguro de que quiere continuar?',
    // allInvoiced: 'Facturado totalmente',
    // partialInvoiced: 'Facturado parcialmente',
    // IndividualByAsset: 'Particular por inmuebles',
    // GlobalToOrder: 'Global',
    // addAppraisalToInvoiceWarningAutoIndividual: 'El importe de la factura será el sumatorio de los importes confirmados de las valoraciones seleccionadas.',
    // addAppraisalToInvoiceWarningAutoGlobal: 'El importe de la factura será el indicado después la selección de las valoraciones.',
    // addAppraisalToInvoiceWarningManual: 'Los datos de facturación serán incluidos de forma manual después de la selección de las valoraciones.',
    // notInvoiced: 'No facturado',
    // testTranslation: 'Test para ver si se hace el merge',
    // filesVolume: 'Volumen de expedientes',
    // filesAverageTime: 'Tiempos medios de expedientes',
    // REQUEST_notCancelled: 'No anuladas',
    // REQUEST_customerInvoiced: 'Valoraciones facturables a cliente',
    // APPRAISALS_notGenerateInvoice: 'No facturar a cliente',

    // REPORT_valuation_summary_element: 'Elemento',
    // REPORT_valuation_summary_registeredPropertyNumber: 'Finca Registral',
    // REPORT_valuation_summary_cadastralReference: 'Referencia Catastral',
    // REPORT_valuation_summary_adoptedSurface: 'Superficie Adoptada (m²)',
    // REPORT_valuation_summary_unitaryValue: 'Valor Unitario (€/m²)',
    // REPORT_valuation_summary_totalValue: 'Valor Total (€)',
    // REPORT_valuation_summary_adoptedMethod: 'Método Adoptado',
    // REPORT_reportVersionSelected: 'Versión del informe seleccionada',
    // REPORT_valuationSummary: 'Resumen de valoraciones',

    // AVM -TRANSLATES
    AVMNationalBankSpainCutomerTypes_1: 'Banco',
    AVMNationalBankSpainCutomerTypes_2: 'Caja de ahorro',
    AVMNationalBankSpainCutomerTypes_3: 'Cooperativas de crédito',
    AVMNationalBankSpainCutomerTypes_4: 'Establecimiento financiero de crédito y sociedades de garantía recíproca',
    AVMNationalBankSpainCutomerTypes_5: 'Entidades aseguradoras',
    AVMNationalBankSpainCutomerTypes_6: 'Administraciones y organismos públicos',
    AVMNationalBankSpainCutomerTypes_7: 'Institución de inversión colectiva inmobiliaria',
    AVMNationalBankSpainCutomerTypes_8: 'Fondo de pensiones',
    AVMNationalBankSpainCutomerTypes_9: 'Sociedad de gestión de activos',
    AVMNationalBankSpainCutomerTypes_10: 'Otras personas jurídicas',
    AVMNationalBankSpainCutomerTypes_11: 'Personas física',

    AVMPurposes_0: 'NotSpecified',
    AVMPurposes_1: 'Mortgage',
    AVMPurposes_2: 'Awarded',

    avm_my_profile: 'Perfil',
    avm_requests: 'Solicitudes',
    avm_list: 'Listado',
    avm_add: 'Añadir',
    avm_valuations: 'Valoraciones',
    avm_dashboard: 'Panel de control',
    avm_massive: 'Masiva',
    avm_portfolios: 'Carteras',
    avm_incidents: 'Incidencias',
    avm_claims: 'Reclamaciones',
    avm_quality_control: 'Control de calidad',
    avm_simple_notes: 'Notas simples',
    avm_entities: 'avm_entities',
    avm_users: 'Usuarios',
    avm_customers: 'Clientes',
    avm_orders: 'Carteras',
    avm_isCompany: 'Es empresa',
    avm_firstName: 'Nombre',
    avm_lastName: 'Apellido',
    avm_email: 'Correo electrónico',
    avm_phone: 'Teléfono',
    avm_nationalBankSpainCode: 'Código del Banco Nacional de España',
    avm_nationalBankSpainCutomerType: 'Tipo de cliente del Banco Nacional de España',
    avm_address: 'Dirección',
    avm_nationalIdentityDocument: 'DNI',
    avm_phoneNumber: 'Número de teléfono',
    avm_logoImageFileName: 'Nombre del archivo de imagen del logotipo',
    avm_add_translation: 'Añadir traducción',
    avm_create_user: 'Crear usuario',
    avm_name: 'Nombre',
    avm_create: 'Crear',
    avm_creating: 'Creando...',
    avm_columns_preselection: 'Preselección de columnas',
    avm_profile: 'Perfil',
    avm_translations: 'Traducciones',
    avm_detail: 'Detalle',
    avm_customerId: 'Cliente',
    avm_purpose: 'Propósito de la valoración',
    avm_customerFullName: 'Cliente',
    avm_addedDateTime: 'Fecha agregada',
    avm_creationDateTime: 'Fecha de creación',
    avm_hasUsers: 'Tiene usuarios',
    avm_add_preselection: 'Añadir preselección',
    avm_edit: 'Editar',
    avm_editing: 'Editando...',
    avm_cancel: 'Cancelar',
    avm_cancelling: 'Cancelando',
    avm_save: 'Guardar',
    avm_saving: 'Guardando...',
    avm_fullName: 'Nombre completo',
    avm_description: 'Descripción',
    avm_description2: 'Denominadores',
    avm_purposes: 'Finalidad',
    avm_orderDateTime: 'Fecha de entrega',
    avm_create_order: 'Crear cartera',
    avm_create_batch: 'Crear lote',
    avm_add_order: 'Añadir cartera',
    avm_input_files: 'Archivos de entrada',
    avm_batch: 'Lote',
    avm_batches: 'Lotes',
    avm_send_to_client: 'Enviar al cliente',
    avm_id: 'Id',
    avm_addedUserFullName: 'Usuario',
    avm_password: 'Contraseña',
    avm_confirmPassword: 'Confirmar contraseña',
    avm_addedUserId: 'ID de usuario agregado',
    avm_lastUpdatedDateTime: 'Fecha de última actualización',
    avm_lastUpdatedUserId: 'ID de usuario de última actualización',
    avm_lastUpdatedUserFullName: 'Nombre de usuario de la última actualización',
    avm_login_information: 'Información login',
    avm_logins_log: 'Logins Log',
    avm_select_file: 'Seleccionar fichero',
    avm_asset: 'Activo',

    InputFileColumns_0: 'Activo',
    InputFileColumns_1: 'Uso',
    InputFileColumns_2: 'Tipología',
    InputFileColumns_3: 'Subtipología',
    InputFileColumns_4: 'País',
    InputFileColumns_5: 'Comunidad Autónoma',
    InputFileColumns_6: 'Código comunidad autónoma',
    InputFileColumns_7: 'Provincia',
    InputFileColumns_8: 'Código provincia',
    InputFileColumns_9: 'Municipio',
    InputFileColumns_10: 'Código municipio',
    InputFileColumns_11: 'Tipo vía',
    InputFileColumns_12: 'Nombre vía',
    InputFileColumns_13: 'Número',
    InputFileColumns_14: 'Portal',
    InputFileColumns_15: 'Bloque',
    InputFileColumns_16: 'Escalera',
    InputFileColumns_17: 'Planta',
    InputFileColumns_18: 'Puerta',
    InputFileColumns_19: 'Resto vía',
    InputFileColumns_20: 'Código postal',
    InputFileColumns_21: 'Coordenada X',
    InputFileColumns_22: 'Coordenada Y',
    InputFileColumns_23: 'Superficie construida',
    InputFileColumns_24: 'Superficie útil',
    InputFileColumns_25: 'Superficie parcela',
    InputFileColumns_26: 'Antigüedad',
    InputFileColumns_27: 'Estado conservación',
    InputFileColumns_28: 'Dormitorios',
    InputFileColumns_29: 'Baños',
    InputFileColumns_30: 'Ascensor',
    InputFileColumns_31: 'Anexo vinculado',
    InputFileColumns_32: 'Num Plazas Garajes',
    InputFileColumns_33: 'Num Trasteros',
    InputFileColumns_34: 'Superficie terraza cubierta (m2)',
    InputFileColumns_35: 'Superficie terraza descubierta (m2)',
    InputFileColumns_36: 'Piscina',
    InputFileColumns_37: 'Zona verde',
    InputFileColumns_38: 'Instalaciones deportivas',
    InputFileColumns_39: 'Superficie garaje vinculado',
    InputFileColumns_40: 'Superficie trastero vinculado',
    InputFileColumns_41: 'Sección censal',
    InputFileColumns_42: 'Información adicional',
    InputFileColumns_43: 'Finca registral',
    InputFileColumns_44: 'Referencia catastral',
    InputFileColumns_45: 'Localidad registro',
    InputFileColumns_46: 'Número registro',
    InputFileColumns_47: 'Prioridad',
    InputFileColumns_48: 'Importe tasación',
    InputFileColumns_49: 'Fecha tasación',
    InputFileColumns_50: 'Fecha solicitud',
    InputFileColumns_51: 'Fecha inicio',
    InputFileColumns_52: 'Fecha fin',
    InputFileColumns_53: 'Rating',
    InputFileColumns_54: 'Número expediente',
    InputFileColumns_55: 'Código población',
    InputFileColumns_56: 'Población',
    InputFileColumns_57: 'VPO',
    InputFileColumns_58: 'Año de construcción',
    InputFileColumns_59: 'Superficie construida con elementos comunes',
    InputFileColumns_60: 'Valor unitario de referencia del elemento principal',
    InputFileColumns_61: 'Valor unitario de referencia del garaje anexo',
    InputFileColumns_62: 'Valor unitario de referencia del trastero anexo',

    avm_save_preselection: 'Guardar preseleccion',
    avm_name_preselection: 'Nombre de la preselección',
    avm_title_preselection: '¿Quieres guardar la preselección?',
    avm_rServerApiState: 'Estado Api Server',
    avm_rServerApiId: 'Server Api ID',
    avm_totalValorationsValue: 'Valor total de la valoración',
    avm_cellSeparator: 'Carácter delimitador',
    avm_batchAssetStates: 'Estado del activo',
    avm_batchAssetTypes: 'Tipos de activo',
    avm_batchAssetOrigins: 'Origen del activo',
    avm_calculatedAvailableDataStates: 'Tipo de información del activo - Calculado',
    avm_originAvailableDataStates: 'Tipo de información del activo - Origen',
    avm_hasAssetCalculated: '¿Tiene un activo calculado asignado?',
    avm_normalizedProcess: 'Proceso de normalización',
    avm_normalized: 'El fichero ya ha sido normalizado.',
    avm_noPendingTranslation: 'Ninguna traducción pendiente. Confirmar para continuar.',

    AvailableDataStatesCustom_0: 'Sin información',
    AvailableDataStatesCustom_1: 'Información de superficie',
    AvailableDataStatesCustom_2: 'Información de tipología',
    AvailableDataStatesCustom_3: 'Información de tipología y superficie',

    Languages_0: 'Español',
    Languages_1: 'Inglés',
    Languages_2: 'Portugués',

    languagesButton: 'Idiomas'

  },
};

const asd = [];
